import * as React from "react";

export enum Orientation {
	left = "left",
	right = "right",
}

export interface ArrowProps {
	visible: boolean;
	display: boolean;
	onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	orientation: Orientation;
}

const Arrow = (props: ArrowProps) => {
	return props.display ? (
		<button
			data-test={`cshp-recommendation-arrow-${
				props.orientation === Orientation.left ? "left" : "right"
			}`}
			aria-label={`${
				props.orientation === Orientation.left ? "Backward" : "Forward"
			}`}
			onClick={props.onClick}
			className={`csrec-arrow csrec-arrow-${props.orientation} ${
				props.visible ? "" : "csrec-arrow-hidden"
			}`}
		>
			<svg width="44" height="44" xmlns="http://www.w3.org/2000/svg">
				<g transform="rotate(-180 22 22)" fill="none" fillRule="evenodd">
					<rect
						stroke="#CCC"
						fill="#FFF"
						x=".5"
						y=".5"
						width="43"
						height="43"
						rx="21.5"
					/>
					<path
						d="M17.3 22.5l9.685 9.684a1 1 0 0 1 0 1.414l-.034.034a1 1 0 0 1-1.414 0l-10.17-10.169a1 1 0 0 1-.259-.963 1 1 0 0 1 .26-.963l10.169-10.17a1 1 0 0 1 1.414 0l.034.035a1 1 0 0 1 0 1.414L17.3 22.5z"
						fill="#666"
					/>
				</g>
			</svg>
		</button>
	) : null;
};

Arrow.displayName = "Arrow";
export default Arrow;
